export const ADD_FIRSTNAME = 'ADD_FIRSTNAME';
export const ADD_LASTNAME = 'ADD_LASTNAME';
export const ADD_TYPE_IDENTIFICATION = 'ADD_TYPE_IDENTIFICATION';
export const ADD_IDENTIFICATION_NUMBER = 'ADD_IDENTIFICATION_NUMBER';
export const ADD_PHONE_NUMBER = 'ADD_PHONE_NUMBER';
export const ADD_EMAIL_USER = 'ADD_EMAIL_USER';
export const ADD_FIRSTNAME_ANOTHER = 'ADD_FIRSTNAME_ANOTHER';
export const ADD_LASTNAME_ANOTHER = 'ADD_LASTNAME_ANOTHER';
export const ADD_BIRTHDATE_ANOTHER = 'ADD_BIRTHDATE_ANOTHER';
export const ADD_IDENTIFICATION_ANOTHER = 'ADD_IDENTIFICATION_ANOTHER';
export const ADD_PHONE_ANOTHER = 'ADD_PHONE_ANOTHER';
export const ADD_EMAIL_ANOTHER = 'ADD_EMAIL_ANOTHER';
export const ADD_CITY_USER = 'ADD_CITY_USER';
export const ADD_COUNTRY_USER = 'ADD_COUNTRY_USER';
export const ADD_PRIMARY_ROAD_USER = 'ADD_PRIMARY_ROAD_USER';
export const ADD_SECONDARY_ROAD_USER = 'ADD_SECONDARY_ROAD_USER';
export const ADD_HOUSE_NUMBER_USER = 'ADD_HOUSE_NUMBER_USER';
export const ADD_BIRTHDATE_USER = 'ADD_BIRTHDATE_USER';
export const ADD_BENEFICIARY = 'ADD_BENEFICIARY';
export const ADD_GENDER_MALE = 'ADD_GENDER_MALE';
export const ADD_GENDER_FEMALE = 'ADD_GENDER_FEMALE';
export const ADD_TYPE_IDENTIFICATION_ANOTHER = 'ADD_TYPE_IDENTIFICATION_ANOTHER';
export const ADD_GENDER_ANOTHER = 'ADD_GENDER_ANOTHER';
export const ADD_EMAILCREATEVALIDATEACCOUNT = 'ADD_EMAILCREATEVALIDATEACCOUNT';
export const ADD_CONFIRM_PASSWORD = 'ADD_CONFIRM_PASSWORD';
export const ADD_PASSWORD_METER = 'ADD_PASSWORD_METER';
export const ADD_PASSWORD_METER_PROGRESS = 'ADD_PASSWORD_METER_PROGRESS';
export const ADD_USERNAME = 'ADD_USERNAME';
export const ADD_PASSWORD = 'ADD_PASSWORD';
export const ADD_CREATE_PASSWORD_USER = 'ADD_CREATE_PASSWORD_USER';
export const ADD_TOKEN_RESET_PASSWORD = 'ADD_TOKEN_RESET_PASSWORD';

type AccountLoginActionType =
    | typeof ADD_FIRSTNAME | typeof ADD_LASTNAME | typeof ADD_IDENTIFICATION_NUMBER | typeof ADD_TYPE_IDENTIFICATION | typeof ADD_PHONE_NUMBER | typeof ADD_EMAIL_USER
    | typeof ADD_PASSWORD_METER | typeof ADD_FIRSTNAME_ANOTHER | typeof ADD_LASTNAME_ANOTHER | typeof ADD_BIRTHDATE_ANOTHER | typeof ADD_IDENTIFICATION_ANOTHER
    | typeof ADD_PASSWORD_METER_PROGRESS | typeof ADD_PHONE_ANOTHER | typeof ADD_EMAIL_ANOTHER | typeof ADD_PRIMARY_ROAD_USER | typeof ADD_SECONDARY_ROAD_USER | typeof ADD_HOUSE_NUMBER_USER
    | typeof ADD_BIRTHDATE_USER |  typeof ADD_BENEFICIARY | typeof ADD_GENDER_MALE | typeof ADD_GENDER_FEMALE 
    | typeof ADD_TYPE_IDENTIFICATION_ANOTHER | typeof ADD_GENDER_ANOTHER | typeof ADD_CITY_USER| typeof ADD_COUNTRY_USER | typeof ADD_EMAILCREATEVALIDATEACCOUNT | typeof ADD_CONFIRM_PASSWORD
    | typeof ADD_USERNAME | typeof ADD_PASSWORD | typeof ADD_CREATE_PASSWORD_USER | typeof ADD_TOKEN_RESET_PASSWORD;

export interface AccountLoginAction {
    type: AccountLoginActionType;
    payload: any;
}

export interface AccountLoginState {
    password: string,
    username: string
}


export interface PasswordConfirmationState {
    password: string,
    confirmationPassword: string,
}

export interface AccountRegisterState extends PasswordConfirmationState {
    id:string,
    firstNameAnother: string,
    lastNameAnother: string,
    birthdateAnother: string,
    identificationAnother: string,
    phoneAnother: string,
    emailAnother: string,
    typeIdentificationAnother: string,
    genderAnother: string,
    birthdateAnotherDate: Date|null,
    civilstatus: string
    acceptTerms: boolean,
    accept_terms_and_conditions: boolean,
    countryAnother: string,
    cityAnother: string
    primaryRoadUser: string,
    secondaryRoadUser:string,
    houseNumberUser:string
    slug: string,
    step:string,
    type_beneficiary:string,
    slug_product:string,
    id_plandetailproduct:string,
    country_code:string,
    status:string
}
export interface QuestionsRequestVA
{
    id:string,
    type_beneficiary:string,
    type_identification: string,
    slug_product:string,
    identification: string,
    firstname: string,
    lastname: string,
    birthdate: string,
    gender: string,
    phone: string,
    email: string,
    id_plandetailproduct:string,
    step: string,
    country_code: string,
    address: address|null,
    beneficiary:beneficiary|null,
    status:string,
    
}
export interface beneficiary
{
    first_name: string,
    last_name: string,
    birthdate: string,
    type_identification:string,
    identification:string,
    gender:string,
    email:string,
    phone:string
}
export interface address
{
    city:string,
    main_street:string,
    secondary_street:string,
    residence_number:string
}

export interface AccountRecoverPasswordState extends PasswordConfirmationState {
    email: string,
    token: string
}

export interface CreateAccountRequest {
    firstName: string,
    lastName: string,
    birthday: string,
    identification: string,
    phone: string,
    email: string,
    type: string,
    gender: string,
    password: string,
    civilstatus: string
    accept_terms_conditions: string,
    country: string,
    city: string,
    slug:string
    
}

export interface List {
    id: string;
    value: string;
}
